

export default function Manager(){
  return(<div className="px-3">
    Manager
  </div>)
}